export const appOutLink = {
  invalidLink: '无效链接',
  copySuccess: '复制成功'
}
